import { AiOutlineClose } from 'react-icons/ai';
import './../css/popup.css'
import './../css/speaker-cv.css'

export const Popup = ({ popupContent, Button, id = 0, small = false }) => {

    // -- unique popup-id
    const popupId = `outer-pop-up-container-${id}`;

    // -- open/close popup
    function togglePopup() {

        // get this specific popup-container
        const popupContainer = document.querySelector(`#${popupId}`);

        const popup = popupContainer.querySelector(".inner-pop-up-container");
        const status = popup.getAttribute("popup-status");

        if (status === "active") {
            popup.setAttribute("popup-status", "");
        }
        else {
            popup.setAttribute("popup-status", "active");
        }

    }

    return (
        <div id={popupId} className="outer-pop-up-container">

            {/* activation of pop-up */}
            <div onClick={togglePopup}>{Button}</div>

            {/* pop-up */}
            <div className="inner-pop-up-container" popup-status="" onClick={togglePopup} >

                <div className={`main-pop-up-container ${small ? "small-popup" : ""}`} onClick={(e) => e.stopPropagation()}>

                    <div className={`pop-up-content ${small ? "no-scrollbar" : ""}`}>
                        {popupContent(togglePopup)}
                    </div>

                    <div className="close-btn" onClick={togglePopup}><AiOutlineClose /></div>

                </div>
            </div>

        </div>
    )
}

export default Popup